import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import Project from '@/projects/entities/project'

@Component
export default class ProjectCard extends Vue {

  @Prop({ required: true })
  private project!: Project

  private get imageUrl() {
    return `${process.env.VUE_APP_API_URL}/project/image?id=${this.project.id}&${Date.now()}`
  }

  private edit() {
    this.$emit('edit', this.project)
  }

  private duplicate() {
    this.$emit('duplicate', this.project)
  }

  private archive() {
    this.$emit('archive', this.project)
  }

  private activate() {
    this.$emit("activate", this.project)
  }
}
